module.exports = __webpack_public_path__ + "static/media/quote.e1222e57.png";